const navLinkConfirmCreateUser = {
  text: 'Go back to home page to enter'
};

export default navLinkConfirmCreateUser;
